import { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Logo from '@comp/Logo/Logo';
import Drawer from '@base/Drawer/Drawer';
import HeaderTop from '@layout/Components/HeaderContainer';
import HeaderContent from '@layout/Components/HeaderParent';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { mediaQuery, Spacings } from '@styles/index';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';
import Dynamic from '@base/Dynamic/Dynamic';

const Login = Dynamic(() => import('@cont/Login/Login'));

const HeaderContainer = styled(HeaderTop)`
  background: ${({ transparent }) =>
    transparent ? 'none' : 'var(--color-base-1)'};
  box-shadow: ${({ transparent }) =>
    transparent ? 'initial' : boxShadowGenerator()};
  position: ${({ transparent }) => (transparent ? 'absolute' : 'sticky')};
  ${mediaQuery.uptoTablet} {
    height: ${Spacings.SPACING_HEADER}px;
  }

  ${mediaQuery.uptoMobile} {
    height: ${Spacings.SPACING_12B};
  }
`;

const HeaderParent = styled(HeaderContent)`
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const RightContentWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

const SimpleHeader = ({ children, transparent, isReload, disabled }) => {
  const { isOpen: showLoginDrawer, closeElement: closeLoginDrawer } =
    useToggleable(LOGIN_DRAWER);

  const onClose = useCallback(() => {
    closeLoginDrawer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Drawer login drawerState={showLoginDrawer} onClose={onClose}>
        {showLoginDrawer && <Login />}
      </Drawer>
      <HeaderContainer transparent={transparent}>
        <HeaderParent>
          <Logo isReload={isReload} disabled={disabled} />
          <RightContentWrapper>{children}</RightContentWrapper>
        </HeaderParent>
      </HeaderContainer>
    </>
  );
};

SimpleHeader.defaultProps = {
  children: null,
  transparent: false,
  isReload: true,
  disabled: false
};

SimpleHeader.propTypes = {
  children: PropTypes.node,
  transparent: PropTypes.bool,
  isReload: PropTypes.bool,
  disabled: PropTypes.bool
};

export default SimpleHeader;
